import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

import * as fragments from '../fragments'

const DOC = gql`
  ${fragments.employee.DOC}
  query SpaceEmployees(
    $tenantId: ID!
    $zoneId: ID!
    $appId: ID!
    $scenarioId: ID!
    $filter: SpaceEmployeeFilter
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          scenario(id: $scenarioId) {
            extra {
              space {
                spaceEmployees(filter: $filter) {
                  ...FragmentSpaceEmployee
                }
              }
            }
          }
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.default(
  graphql.transformers.OUT.select<
    graphql.schema.SpaceEmployeesQuery,
    ents.extra.space.Employee[],
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'app',
        graphql.transformers.OUT.select(
          'scenario',
          graphql.transformers.OUT.select(
            'extra',
            graphql.transformers.OUT.select(
              'space',
              graphql.transformers.OUT.select(
                'spaceEmployees',
                graphql.transformers.OUT.list(fragments.employee.TRANSFORMER, {
                  onNullish: 'remove',
                }),
              ),
            ),
          ),
        ),
      ),
    ),
  ),
  [],
)

export const executor = graphql.createExecutor<
  graphql.schema.SpaceEmployeesQuery,
  ents.extra.space.Employee[],
  graphql.schema.SpaceEmployeesQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
